import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatErr } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Selamat datang kembali!");
      const from = location.state?.from?.pathname || (u.role === "admin" ? "/admin" : "/");
      navigate(from, { replace: true });
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Login gagal");
    } finally { setLoading(false); }
  };
  return (
    <div className="min-h-[calc(100vh-5rem)] lumina-bg-soft flex items-center justify-center py-16" data-testid="login-page">
      <div className="lumina-card w-full max-w-md p-10">
        <div className="lumina-label mb-2">Masuk</div>
        <h1 className="font-serif text-4xl text-[#1A1728] mb-8">Selamat datang kembali.</h1>
        <form onSubmit={submit} className="space-y-4">
          <input required type="email" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-[#E2DFED] focus:border-[#6B4BA3] focus:ring-2 focus:ring-[#6B4BA3]/20 outline-none" data-testid="login-email" />
          <input required type="password" placeholder="Password" value={password} onChange={e=>setPassword(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-[#E2DFED] focus:border-[#6B4BA3] focus:ring-2 focus:ring-[#6B4BA3]/20 outline-none" data-testid="login-password" />
          <button disabled={loading} className="lumina-btn-primary w-full" data-testid="login-submit">{loading ? "Memproses…" : "Masuk"}</button>
        </form>
        <p className="text-sm text-[#5C5870] mt-6 text-center">Belum punya akun? <Link to="/register" className="text-[#6B4BA3] font-medium" data-testid="register-link">Daftar di sini</Link></p>
        <div className="mt-6 p-4 bg-[#E8F0FA] rounded-xl text-xs text-[#5C5870]">
          <p className="font-medium text-[#6B4BA3] mb-1">Demo:</p>
          <p>Admin: admin@hearinsight.id / HearInsight2026!</p>
          <p>User: user@hearinsight.id / User2026!</p>
        </div>
        <p className="text-sm text-center mt-4"><Link to="/forgot-password" className="text-[#6B4BA3] hover:underline" data-testid="forgot-link">Lupa password?</Link></p>
      </div>
    </div>
  );
}
